/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var CredoOptionInput;
(function (CredoOptionInput) {
    CredoOptionInput["ACTION"] = "ACTION";
    CredoOptionInput["NO"] = "NO";
    CredoOptionInput["YES"] = "YES";
})(CredoOptionInput || (CredoOptionInput = {}));
export var Permission;
(function (Permission) {
    Permission["Admin"] = "Admin";
    Permission["Read"] = "Read";
    Permission["Write"] = "Write";
})(Permission || (Permission = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
